import { calculateBoxSizes as r } from "./highrise1391.mjs";
import { freeze as t } from "./highrise1747.mjs";
var s = /* @__PURE__ */ function() {
  function i(o) {
    var e = r(o);
    this.target = o, this.contentRect = e.contentRect, this.borderBoxSize = t([e.borderBoxSize]), this.contentBoxSize = t([e.contentBoxSize]), this.devicePixelContentBoxSize = t([e.devicePixelContentBoxSize]);
  }
  return i;
}();
export {
  s as ResizeObserverEntry
};
